{
  "myData.export.section.heading": "Tietojen lataaminen",
  "myData.export.section.description": "Voit ladata itsellesi tiedot, joita tämä palvelu sinusta säilyttää. Toisessa palvelussa hallinnoituja tietoja ei sisällytetä latauksiin, vaan ne näkyvät linkkeinä.",
  "myData.export.trigger": "Lataa tietoni",
  "myData.export.pending": "Valmistellaan…",
  "myData.export.ready": "Tietosi ovat valmiina ladattaviksi.",
  "myData.export.download.json": "Lataa koneluettava tiedosto (JSON)",
  "myData.export.download.text": "Lataa luettava tiedosto (teksti)",
  "myData.export.close": "Sulje",
  "myData.export.error": "Tietojen lataaminen epäonnistui. Yritä uudelleen."
}
